import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import axios, { AxiosStatic } from 'axios';
import { ToastPlugin, ModalPlugin, IconsPlugin } from 'bootstrap-vue';
import moment from 'moment';
import { AppUserData } from '@/types/AppUser';
import MsalPlugin, { MSALBase } from '@/types/Authentication';
import Msal from 'msal';

Vue.config.productionTip = false;

Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(IconsPlugin);
Vue.use(MsalPlugin, {
    configuration: {
        auth: {
            clientId: process.env.VUE_APP_MSAL_AUTHENTICATION_CLIENT_ID
            , authority: process.env.VUE_APP_MSAL_AUTHENTICATION_AUTHORITY
            , redirectUri: `${window.location.protocol}//${window.location.host}/login` // process.env.VUE_APP_MSAL_REDIRECT_URL
            , postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}/login` //process.env.VUE_APP_MSAL_REDIRECT_URL
            , navigateToLoginRequestUrl: true
        },
        cache: {            
            cacheLocation: 'sessionStorage'
            , storeAuthStateInCookie: true
        },
        system: {
            tokenRenewalOffsetSeconds: 300
        }
    },
    request: {
        scopes: [process.env.VUE_APP_MSAL_AUTHENTICATION_SCOPE]
    },
    autoRefreshToken: true,
    callbacks: {
        onToken: (ctx: object, error: Msal.AuthError | null, response: Msal.AuthResponse | null) => {
            if (response) {
                store.dispatch('setApiAccessToken', response.accessToken);
                return;
            }
            console.log(error);
        }
    }
});

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$appUser = null;
Vue.prototype.$publicPath = process.env.BASE_URL;
Vue.prototype.$environment = process.env.VUE_APP_ENV;

declare module 'vue/types/vue' {
    interface Vue {
        $axios: AxiosStatic;
        // eslint-disable-next-line
        $moment: any;
        $appUser: AppUserData | null;
        $msal: MSALBase;
        // eslint-disable-next-line
        $environment: any;
    }
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
